export const resizeWithCrop = (file, targetWidth, targetHeight, cropPosition = "left-top") => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const originalWidth = img.width;
            const originalHeight = img.height;

            // ✅ クロップサイズを決定（短い辺を基準に）
            const minSide = Math.min(originalWidth, originalHeight);
            const availableSizes = [128, 256, 512, 1024, 2048];
            const bestSize = availableSizes.filter(size => size <= minSide).reduce((a, b) => Math.max(a, b), availableSizes[0]);

            const finalWidth = Math.min(targetWidth, bestSize, originalWidth);
            const finalHeight = Math.min(targetHeight, bestSize, originalHeight);

            // ✅ キャンバス設定
            canvas.width = finalWidth;
            canvas.height = finalHeight;

            // ✅ クロップ開始位置を計算
            let startX = 0, startY = 0;

            switch (cropPosition) {
                case "top-left":
                    startX = 0;
                    startY = 0;
                    break;
                case "top-center":
                    startX = (originalWidth - targetWidth) / 2;
                    startY = 0;
                    break;
                case "top-right":
                    startX = originalWidth - targetWidth;
                    startY = 0;
                    break;
                case "center":
                    startX = (originalWidth - targetWidth) / 2;
                    startY = (originalHeight - targetHeight) / 2;
                    break;
                case "bottom-right":
                    startX = originalWidth - targetWidth;
                    startY = originalHeight - targetHeight;
                    break;
                case "bottom-left":
                    startX = 0;
                    startY = originalHeight - targetHeight;
                    break;
                default:
                    // defaultケースを追加
                    console.warn(`Unknown cropPosition: ${cropPosition}. Using "top-left" as default.`);
                    startX = 0;
                    startY = 0;
                    break;
            }

            // ✅ 座標が範囲外に飛び出さないように修正
            startX = Math.max(0, Math.min(startX, originalWidth - finalWidth));
            startY = Math.max(0, Math.min(startY, originalHeight - finalHeight));

            // 💡 クロップ範囲と描画範囲を個別計算
            const cropWidth = Math.min(finalWidth, originalWidth - startX);
            const cropHeight = Math.min(finalHeight, originalHeight - startY);

            // ✅ 正確なクロップと描画処理
            ctx.drawImage(img, startX, startY, cropWidth, cropHeight, 0, 0, finalWidth, finalHeight);

            // ✅ 画像を Blob に変換
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve({
                        url: URL.createObjectURL(blob),
                        width: finalWidth,
                        height: finalHeight,
                        originalName: file.name.replace(/\.[^/.]+$/, ""),
                        originalWidth,
                        originalHeight
                    });
                } else {
                    reject(new Error('画像の変換に失敗しました'));
                }
            }, 'image/png');
        };

        img.onerror = (err) => reject(err);

        const reader = new FileReader();
        reader.onload = (e) => (img.src = e.target.result);
        reader.readAsDataURL(file);
    });
};
